import { useState } from 'react';
import {
  DropdownMenu,
  DropdownToggle,
  Spinner,
  UncontrolledDropdown
} from 'reactstrap';
import { PackageStatus, UserMemberhsip } from '../types';
import { MarkAsPaid, MarkAsPaidModal } from './markAsPaid';

export const PackageOrdersActions = (cell: any) => {
  const [isOpen, setIsOpen] = useState(0);

  const { id, status }: UserMemberhsip = cell.row.original;

  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle
          href='#'
          className='btn btn-soft-secondary btn-sm'
          tag='button'>
          <i className='ri-more-fill' />
        </DropdownToggle>

        <DropdownMenu className='dropdown-menu-end'>
          {status === PackageStatus.PENDING && (
            <MarkAsPaid isOpen={isOpen} setIsOpen={setIsOpen} />
          )}
        </DropdownMenu>
      </UncontrolledDropdown>

      {status === PackageStatus.PENDING && (
        <MarkAsPaidModal id={id} isOpen={isOpen} setIsOpen={setIsOpen} />
      )}
    </>
  );
};

export default PackageOrdersActions;
